import React from "react";
import classes from "./Table.module.css";

const Table = ({ children, className }) => {
    return (
        <table className={`${classes.Table} ${className || ""}`}>
            {children}
        </table>
    );
};

const TableHeader = ({ children, dropClass }) => {
    return (
        <thead>
            <tr className={`${classes.TableHeader} ${dropClass || ""}`}>
                {children}
            </tr>
        </thead>
    );
};

const HeaderColumn = ({ children, dropClass }) => {
    return (
        <th className={`${classes.Th} ${dropClass || ""}`}>
            {children}
        </th>
    );
};

const TableBody = ({ children }) => {
    return (
        <tbody className={classes.TableBody}>
            {children}
        </tbody>
    );
};

const Row = ({ children, dropClass, onClickRow }) => {
    return (
        <tr
            className={`${classes.Row} ${onClickRow ? classes.Clickable : ""} ${dropClass || ""}`}
            onClick={onClickRow}
        >
            {children}
        </tr>
    );
};

const Column = ({ children, dropClass, colSpan }) => {
    return (
        <td className={`${classes.Td} ${dropClass || ""}`} colSpan={colSpan}>
            {children}
        </td>
    );
};

export { Table, TableHeader, HeaderColumn, TableBody, Row, Column };
